import script from "./MoveSort.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveSort.vue?vue&type=script&setup=true&lang=js"

import "./MoveSort.vue?vue&type=style&index=0&id=aa39b38c&lang=stylus&scoped=true"

import exportComponent from "/root/.jenkins/workspace/prod-market-pc-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa39b38c"]])

export default __exports__